import S3 from 'aws-sdk/clients/s3'

const uploadToBucket = async (file) => {
  const fileName = (`${new Date() / 1 }`)

  const bucket = new S3({
    region: process.env.VUE_APP_S3_REGION,
    accessKeyId: process.env.VUE_APP_S3_ACCESSKEYID,
    secretAccessKey: process.env.VUE_APP_S3_SECRETACCESSKEY,
    params: {
      Bucket: `${process.env.VUE_APP_S3_BUCKET}/gw-crm/${fileName}`
    }
  })

  const sizes = ['240', '300', '460', '700', '1040']
  const promises = []
  sizes.forEach((size) => {
    const params = {
      Key: size,
      ContentType: file.type,
      Body: file,
      ACL: 'public-read'
    }

    promises.push(new Promise((resolve, reject) => {
      bucket.putObject(params, function putToBucket (err) {
        if (err) {
          reject(err)
        } else {
          resolve(this.request.params)
        }
      })
    }))
  })

  return Promise.all(promises)
}

export default uploadToBucket

export {
  uploadToBucket
}
